module.exports = __webpack_public_path__ + "img/15_85.40be9852.png";